import { Routes } from '@angular/router';
import { canActivateAuthorized } from '@app/core/auth';
import { NotFoundPageComponent } from '@app/pages-core/not-found-page/not-found-page.component';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('@app/pages-core/auth-pages').then((r) => r.AUTH_PAGES_ROUTES),
  },
  {
    path: 'login',
    pathMatch: 'full',
    redirectTo: '/auth/login',
  },
  {
    path: '',
    loadChildren: () => import('@app/pages-core/main-container-page').then((r) => r.MAIN_CONTAINER_PAGE_ROUTES),
    canActivate: [canActivateAuthorized],
  },
  {
    path: '**',
    component: NotFoundPageComponent,
  },
];
